import { useStripe } from '@stripe/react-stripe-js';
import * as stripeJs from '@stripe/stripe-js';

export default useStripe;

export type TStripe = stripeJs.Stripe;
